import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from '../product-detail-updated/product-detail-updated.module';
import { MAddressListRequest, MAddressListResponse, MAddressRequest, MAddressResponseData, MUserProfileRequest, MUserProfileResponseData } from '../user/user.module';
import { MCheckoutRequest } from './checkout-new.module';
import { WsCheckoutService } from 'src/app/ws/wsCheckout/ws-checkout.service';
import { WsFooterService } from 'src/app/ws/wsFooter/ws-footer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MGetProductRequest } from '../product/product.module';
import { ToastrService } from 'ngx-toastr';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
declare var $: any;

@Component({
  selector: 'app-checkout-new',
  templateUrl: './checkout-new.component.html',
  styleUrls: ['./checkout-new.component.scss']
})
export class CheckoutNewComponent {
  @ViewChild('content')
  content!: ElementRef;
  newPay: boolean = false;
  offers: boolean = false;
  checkoutPageForm!: FormGroup;
  emailFormgroup!: FormGroup;
  mWishlistData: any = [];
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule();
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  subTotalAmount: any = 0;
  totalAmount: any = 0;
  mAddressReq: MAddressRequest = new MAddressRequest();
  mAddressListResponse: MAddressListResponse = new MAddressListResponse()
  id: any;
  mCheckoutRequest: MCheckoutRequest = new MCheckoutRequest()
  defaultAddress: any = [];
  addressId: any;
  state: any;
  mProductModal: any = '';
  mGetProductRequest: MGetProductRequest = new MGetProductRequest()
  products: any = [];
  url!: SafeResourceUrl;
  showIframe: boolean = false;
  productPrice: any = null;
  productId: any = null;
  taxes: any;
  taxableAmount: any = 0;
  discountCode: any = '';
  discount: any;
  discountApplied: any = null;
  routerUrl: any;
  productIds: any = [];
  brandIds: any = [];
  categoryIds: any = [];
  discountAmount: any = null;
  taxableAmountCalculate: any = 0;
  discountList: any;
  discountId: any = null;
  ProductIds: any;
  BrandIds: any;
  CategoryIds: any;
  type: any;
  viewOffers: any = false;
  totalItems: any = 0;
  addressData: any;
  viewForm: any = '';
  selectedAddress: any;
  fullAddressArray: any = []
  showDiscountOnTotal: boolean = false;
  totalAmountWithoutDiscount: any = 0;
  profileData: any;
  wishlistData: any = [];
  totalAmountLast: any = 0;
  shippingCharge: number = 0;
  payment: boolean = false;
  getSelectedAddress: boolean = false;
  applyDiscountFromCart: boolean = false;
  isLoadingPay: boolean = false;
  showDelete: boolean = false
  get checkoutPagef() {
    if (this.checkoutPageForm) {
      return this.checkoutPageForm.controls;
    }
    return null;
  }
  mUserProfileReq: MUserProfileRequest = new MUserProfileRequest();
  mUserProfileData: MUserProfileResponseData = new MUserProfileResponseData();
  mAddressListReq: MAddressListRequest = new MAddressListRequest();
  paymentType: any = '';
  mAddressResponseData?: MAddressResponseData;
  addAndSelectAddress!: boolean;
  addPaymentMethod!: boolean;
  showCart: boolean = true;
  showPayment: boolean = false;
  showAddress: boolean = false;
  newSelectAddressId: any;

  constructor(private modalService: NgbModal,private _formBuilder : FormBuilder,
    private renderer: Renderer2,
    private _commonBehaviorChangeService: CommonBehaviorChangeService,
    private toast: ToastrService, private activatedRoute: ActivatedRoute,
    private domSanitizer: DomSanitizer, private router: Router,
    private wsFooter: WsFooterService, private wsCheckoutService: WsCheckoutService,
    private formBuilder: FormBuilder, private wsShopAllService: WsShopallService,
    private wsUserProfileService: WsUserProfileService) {
    this._commonBehaviorChangeService.currentAddCart.subscribe((cartList: any) => {
      if (cartList) {
        if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
          setTimeout(() => {
            this.getWishList()
          }, 500);
        }
      }
      
    })
    this._commonBehaviorChangeService.currentAddWishlist.subscribe((wishList: any) => {
      if (wishList) {
        if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
          setTimeout(() => {
            this.getWishList()
          }, 500);
        }
      }
    })
    this.activatedRoute.params.subscribe(params => {
      if(params['productId']){
        this.productId = params['productId']
      }
      if(params['discountCode']){
        this.discountCode = params['discountCode']
        this.applyDiscountFromCart = true;
      }
    })
  }

  clickCart(){
    this.showCart = !this.showCart;
  }

  clickPayment(){
    this.showPayment = !this.showPayment;
  }

  clickAddress(){
    this.showAddress = !this.showAddress;
  }

  scrollToTop() {    
  // Use nativeElement.scrollTop to scroll to the top of the content
     
  this.content.nativeElement.scrollTop = 0;   
}


  // Function to scroll the div to the top
  scrollToView() {
    let element: any = document.getElementById("addressaccrodian")
    const yOffset = -100;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });

  }
  scrollToViewPayment() {
    let element: any = document.getElementById("paymentView")
    const yOffset = -100;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  scroll(val: any){
    let element: any = document.getElementById(val)
    const yOffset = -100;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  scrollToViewOffers() {
    
    let element: any = document.getElementById("offersView1")
    const yOffset = -100;
    if(element){
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  boolOffer!: boolean

  mobileAddress: boolean = false;
  cartAddress: boolean = true;
  mobilePaymentClick: boolean = false;
  mobileOfferClick: boolean = false;
  cartAmount: number = 499;

  mobilePayClick() {
    this.mobileAddress = true;
    this.cartAddress = false;
    this.mobilePaymentClick = false;
    this.mobileOfferClick = false;
    const mobilePay = document.querySelectorAll('.m-c-blue');
    this.addAndSelectAddress = true
    mobilePay.forEach(element => {
      element.classList.add('m-c-blue-new');
    })
    $('#collapseOne').collapse('hide');
    $('#collapseTwo').collapse('show');
    setTimeout(() => {
      this.scrollToView()
    }, 500);
  }

  mobileAddressClick() {
    this.mobileAddress = false;
    this.cartAddress = false;
    this.mobilePaymentClick = true;
    this.mobileOfferClick = false;
    this.addPaymentMethod = true
    const mobileAddressClick = document.querySelectorAll('.m-c-orange');
    mobileAddressClick.forEach(element => {
      element.classList.add('m-c-orange-new');
    })
    $('#collapseTwo').collapse('hide');
    $('#collapseThree').collapse('show');
    setTimeout(() => {
      this.scrollToViewPayment()
    }, 500);
  }

  offerClick(bool?: boolean) {
   
    const m_stepper_detail = document.querySelectorAll('.m-stepper-detail');
    m_stepper_detail.forEach(element => {
      element.classList.add('hide');
    })

    if (bool) {
      this.boolOffer = bool;
    }
    else {
      this.boolOffer = false;
    }
    const row = document.querySelectorAll('.row');
    row.forEach(element => {
      element.classList.add('hide');
    })
    this.mobileOfferClick = true;
    setTimeout(() => {
      this.scrollToViewOffers()
      //this.scrollToTop()
  }, 200);
  }

  backOfferClick() {

    if(this.boolOffer == false && this.addPaymentMethod == true) {
      this.mobileOfferClick = false;
      this.mobileAddress = false;
      this.cartAddress = false;
      this.mobilePaymentClick = true;
      this.showCart = false;
      this.showAddress = false;
      this.showPayment = true;
      const m_stepper_detail = document.querySelectorAll('.m-stepper-detail');
      m_stepper_detail.forEach(element => {
        element.classList.remove('hide');
      })

      const row = document.querySelectorAll('.row');
      row.forEach(element => {
        element.classList.remove('hide');
      })
      $('#collapseThree').collapse('show');

      setTimeout(() => {
        this.scroll('paymentView');
      }, 500);
    }
    else if(this.boolOffer == false && this.addAndSelectAddress == true){
      this.mobileAddress = true;
      this.cartAddress = false;
      this.mobilePaymentClick = false;
      this.mobileOfferClick = false;
      this.showCart = false;
      this.showAddress = true;
      this.showPayment = false;
      const m_stepper_detail = document.querySelectorAll('.m-stepper-detail');
      m_stepper_detail.forEach(element => {
        element.classList.remove('hide');
      })
      const row = document.querySelectorAll('.row');
      row.forEach(element => {
        element.classList.remove('hide');
      })
      $('#collapseTwo').collapse('show');

      setTimeout(() => {
        this.scroll('addressaccrodian')
      }, 500);
    }
    else {
      this.mobileAddress = false;
      this.cartAddress = true;
      this.mobilePaymentClick = false;
      this.mobileOfferClick = false;
      this.showCart = true;
      this.showAddress = false;
      this.showPayment = false;
      const m_stepper_detail = document.querySelectorAll('.m-stepper-detail');
      m_stepper_detail.forEach(element => {
        element.classList.remove('hide');
      })
      const row = document.querySelectorAll('.row');
      row.forEach(element => {
        element.classList.remove('hide');
      })
      $('#collapseOne').collapse('show');

      setTimeout(() => {
        this.scroll('cart-accordion')
      }, 500);
    }
  }

  clickPay(pay: any) {
    if(this.mUserProfileData.email == null || this.mUserProfileData.email == ''){
      $('#email-update').show();
      $("#email-update").attr("class", function(i:any, origValue:any){
        return origValue + " show";
     })
     this.profileData = {
      'first_name':this.mUserProfileData.first_name,
      'last_name': this.mUserProfileData.last_name,
      'id':this.id,
      'email':this.emailFormgroup.controls['email'].value
    }
    }
    else{
      if(this.selectedAddress){
        if (pay == 'pay') {
          this.newPay = true;
        }
        const clickPay = document.querySelectorAll('.bg-opacity-white');
        clickPay.forEach(element => {
          element.classList.remove('bg-opacity-white');
        })
    
        const checkoutLeft = document.querySelectorAll('.checkout-left');
        checkoutLeft.forEach(element => {
          element.classList.add('stepper-bg');
        })
      }
    }
  }

  clickOffers(offer: any) {
   
    if (offer == 'on') {
      this.offers = true;
    }
    if (offer == 'off') {
      this.offers = false
    }
  }

  async ngOnInit() {
    this.emailFormgroup = this._formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
    });
    var paymentDeclined = localStorage.getItem('orderType');
    this.routerUrl = this.router.url;
   
    this.id = SharedPrefrences.getUserId();
    this.mUserProfileReq.id = this.id
    await this.getUserPofile(this.mUserProfileReq)
    this.mAddressListReq.userId = this.id
    this.getWishList();
    var selectedAddressId = localStorage.getItem("addressSelected")
    await this.getAddressList(this.mAddressListReq)
    if (paymentDeclined == 'cart' || paymentDeclined == 'buynow') {
      const userAgent = window.navigator.userAgent.toLowerCase();
      var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
      if (mobile) {
        await this.getAddressList(this.mAddressListReq)
        this.mobileAddressClick();
      } else {
        this.clickPay('pay')
      }
      if(selectedAddressId){
        this.selectedAddress = this.mAddressListResponse.data.filter((address: any) => address.id == selectedAddressId)[0];
      }

    }

    window.scroll(0, 0)

    if(this.router.url.indexOf('/checkout-new/buynow') != -1 || this.router.url.indexOf('/checkout-new-mob/buynow') != -1){
      this.showDelete = true;
    }
    else{
      this.showDelete = false;
    }
  }

  async getWishList() {
    const wishList = this.wsUserProfileService.getWishList("" + SharedPrefrences.getUserId())
    await lastValueFrom(wishList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mWishlistData = response.data
        if (this.router.url.indexOf('/checkout-new/buynow') == -1 && this.router.url.indexOf('/checkout-new-mob/buynow') == -1) {
          this.getAllCartProducts()
        } else {
          var produtDetail = JSON.parse("" + localStorage.getItem("buynow"))
          var productId = this.productId;
          this.getProductById(productId, produtDetail.qty);
        }
      }
    })
  }

  async addToCartBuyNow(event:any){
    if(event.productdetail){
      this.mAddUpdateCartModuleResponse.data.push(event);
      await this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product['productdetail'].cartQty = cartPresent[0].qty;
        }
      })
     await this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.forEach((cartItem: any) => {
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === cartItem.productdetail.id && cartItem.qty > 0) });
          if (present) {
            cartItem.like = true;
          } else {
            cartItem.like = false;
          }
        }
      })
      this.wishlistData = this.mWishlistData.filter((product:any) => !product['productdetail'].cartQty || product['productdetail'].cartQty < 1)
      this.calculateTotal()
      this.calculateTotalAmount();
    }
  }

  /**
 * Date:- 13-06-2023
 * Method :- This method is used to Get User Profile Details
 * @param id :-  This param is used for request to Get Profile Details
 */
  async getUserPofile(id: MUserProfileRequest) {
    const userProfile = this.wsUserProfileService.getUserProfile(id)
    await lastValueFrom(userProfile).then(async response => {
      if (response && response.statusCode == 200) {
        this.mUserProfileData = response.data
      }
    })
  }

  /**
   * Date: 10-06-23
   * Method: This method is used to get all product by parameter passed
   */
  async getProductById(productId: any, qty: any) {
    this.mGetProductRequest.product_id = productId;
    const getAllProductByParameters = this.wsShopAllService.getAllProductByParameters(this.mGetProductRequest)
    await lastValueFrom(getAllProductByParameters).then(async response => {
      const productDetail = {
        productdetail: response.data[0],
        product_id: response.data[0].id,
        qty: qty
      }

      if (response.data[0].taxes && response.data[0].taxes.length > 0) {
        this.taxes = response.data[0].taxes[0]
      }
      if (response.data[0].extras.length > 0) {
        response.data[0].extras.forEach((size: any) => {
          if (size.id == this.productId) {
            productDetail.productdetail['size'] = size.size;
            productDetail.productdetail['your_price'] = size.your_price;
            this.productPrice = size.your_price;
            if (size && size.color_list && size.color_list.length > 0) {
              var selectedColor = size.color_list.filter((color: any) => color.id == this.productId)
              if (selectedColor.length > 0) {
                productDetail.productdetail['color'] = selectedColor[0].color;
                productDetail.productdetail['your_price'] = selectedColor[0].your_price;
                this.productPrice = selectedColor[0].your_price;
              }
            }
          } else {
            if (size && size.color_list && size.color_list.length > 0) {
              size.color_list.forEach((color: any) => {
                if (color.id == this.productId) {
                  productDetail.productdetail['size'] = size.size;
                  productDetail.productdetail['color'] = color.color;
                  productDetail.productdetail['your_price'] = color.your_price;
                }
              })
            }
          }
        })
      }
      this.mAddUpdateCartModuleResponse.data = []
      this.mAddUpdateCartModuleResponse.data.push(productDetail)
      await this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
        const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
        if (cartPresent.length > 0) {
          product['productdetail'].cartQty = cartPresent[0].qty;
        }
      })
     await this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.forEach((cartItem: any) => {
        if (this.mWishlistData && this.mWishlistData.length > 0) {
          const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === cartItem.productdetail.id && cartItem.qty > 0) });
          if (present) {
            cartItem.like = true;
          } else {
            cartItem.like = false;
          }
        }
      })
      this.wishlistData = this.mWishlistData.filter((product:any) => !product['productdetail'].cartQty || product['productdetail'].cartQty < 1)
      this.calculateTotal()
      if(this.applyDiscountFromCart){
        this.applyDiscount(this.discountCode,true)
      }
      if(this.discountId && !this.applyDiscountFromCart){
        this.applyDiscount(this.discountCode)
      }
    })
  }


  /**
 * Date:- 13-06-2023
 * Method :- This method is used to Get Address List
 * @param userId :-  This param is used for request to Get Address List
 */
  async getAddressList(userId: MAddressListRequest) {
    this.mAddressListResponse.data = []
    const addressList = this.wsUserProfileService.getAddressList(userId)
    await lastValueFrom(addressList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddressListResponse.data = response.data
        if (this.mAddressListResponse.data.length > 0) {
          this.defaultAddress = this.mAddressListResponse.data.filter((address: any) => address.is_default == true);
          let regularAddress = this.mAddressListResponse.data.filter((address: any) => address.is_default == false);
          this.fullAddressArray = this.defaultAddress.concat(regularAddress);

          if(this.getSelectedAddress == true){
            let newAddressAray = this.fullAddressArray.filter((address: any) => {return address.id == this.newSelectAddressId});
            if(this.defaultAddress && this.defaultAddress.length>0){
              this.selectedAddress = this.defaultAddress[0];
            }
            else{
              this.selectedAddress = newAddressAray[0];
            }
            this.getSelectedAddress = !this.getSelectedAddress;
          }
          else{
            this.selectedAddress = this.defaultAddress[0]
          }
  
        } else {
          this.fullAddressArray = [];
          this.defaultAddress = [];
        }
      }
    })
  }

  addressChange(address: any) {
    this.selectedAddress = address;
  }


  addUpdateAddress(val: any, address?: MAddressResponseData) {
    this.addressData = address;
    this.viewForm = val;
    if(address){
      if(this.selectedAddress == address){
        this.getSelectedAddress = true;
        this.newSelectAddressId = this.selectedAddress.id;
      }
      else{
        this.getSelectedAddress = true;
        this.newSelectAddressId = this.selectedAddress.id;
      }
    }
    else{
      this.getSelectedAddress = false;
      this.newSelectAddressId = null;
    }
  }
  /**
   * Date: 10-06-23
   * Method : This method is used to get all cart items 
   */
  async getAllCartProducts() {
    const getAllCart = this.wsShopAllService.getCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(getAllCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModuleResponse.data = response.data;
        await this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product['productdetail'].cartQty = cartPresent[0].qty;
          }
        })
       await this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.forEach((cartItem: any) => {
          if (this.mWishlistData && this.mWishlistData.length > 0) {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === cartItem.productdetail.id && cartItem.qty > 0) });
            if (present) {
              cartItem.like = true;
            } else {
              cartItem.like = false;
            }
          }
        })
        this.wishlistData = this.mWishlistData.filter((product:any) => !product['productdetail'].cartQty || product['productdetail'].cartQty < 1)
        await this.calculateTotal()
        if(this.applyDiscountFromCart){
          this.applyDiscount(this.discountCode)
        }
      }
    })
  }

  async removeAddress(addressId: any) {
    const removeAddress = this.wsUserProfileService.removeAddress(addressId)
    await lastValueFrom(removeAddress).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddressListReq.userId = this.id
        this.getAddressList(this.mAddressListReq)
      }
    })
  }


  async calculateTotal() {
    if (this.mAddUpdateCartModuleResponse.data.length < 1 && (this.router.url.indexOf('/checkout-new/cart') != -1 || this.router.url.indexOf('/checkout-new-mob/cart') != -1)) {
      this.toast.error("Please add some products to checkout and buy.")
      this.router.navigate(['home-page'])
    }
    this.subTotalAmount = 0;
    this.totalItems = 0;
    this.mCheckoutRequest.productorderdetails = []
    this.mCheckoutRequest.warehouse_id = this.mAddUpdateCartModuleResponse.data[0].productdetail.warehouse_id
    await this.mAddUpdateCartModuleResponse.data.forEach((cartItem: any) => {
      this.productIds.push(cartItem.product_id)
      this.brandIds.push(cartItem.productdetail.brand_id)
      this.categoryIds.push(cartItem.productdetail.category_id)
      this.ProductIds = this.productIds.length < 2 ? this.productIds[0] : this.productIds.join(',')
      this.BrandIds = this.brandIds.length < 2 ? this.brandIds[0] :  this.brandIds.join(',')
      this.CategoryIds = this.categoryIds.length < 2 ? this.categoryIds[0] : this.categoryIds.join(',')
      this.getAllDiscount()
      this.mCheckoutRequest.productorderdetails.push({
        "product_id": cartItem.product_id ? cartItem.product_id : cartItem.productdetail.id,
        "qty": cartItem.qty,
        "product_price": cartItem.productdetail.your_price,
        "hsn": cartItem.productdetail.hsn,
        "tax": 0,
      })
      if (this.mWishlistData && this.mWishlistData.length > 0) {
        const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === cartItem.productdetail.id && cartItem.qty > 0) });
        if (present) {
          cartItem.like = true;
        }
      }
      this.totalItems = this.totalItems + cartItem.qty;
      if (this.subTotalAmount == 0) {
        this.subTotalAmount = (parseInt(cartItem.productdetail.your_price) * parseInt(cartItem.qty))
      } else {
        this.subTotalAmount = this.subTotalAmount + (parseInt(cartItem.productdetail.your_price) * parseInt(cartItem.qty))
      }
    
    })
  }

  calculateIndividualTotal(qty: any, price: any) {
    return qty *  price;
  }

  /**
 * Date:- 13-06-2023
 * Method :- This method is used to Add Address
 * @param mAddressReq :-  This param is used for request to Add Address Details
 */
  async addAddress() {
    this.mAddressReq.use_id = "" + SharedPrefrences.getUserId();
    this.mAddressReq.title = 'Home'
    this.mAddressReq.name = this.checkoutPageForm.controls['first_name'].value + ' ' + this.checkoutPageForm.controls['last_name'].value
    this.mAddressReq.address_line1 = this.checkoutPageForm.controls['address_line1'].value
    this.mAddressReq.address_line2 = this.checkoutPageForm.controls['address_line2'].value
    this.mAddressReq.country_id = 2;
    this.mAddressReq.country_name = ""
    this.mAddressReq.state_name = this.checkoutPageForm.controls['state_name'].value
    this.mAddressReq.city = this.checkoutPageForm.controls['city'].value
    this.mAddressReq.postal_code = this.checkoutPageForm.controls['postal_code'].value
    this.mAddressReq.is_default = true;
    this.mAddressReq.contact_number1 = this.checkoutPageForm.controls['phone'].value
    this.mAddressReq.email = this.checkoutPageForm.controls['email'].value

    const addAddress = this.wsUserProfileService.addAddress(this.mAddressReq)
    await lastValueFrom(addAddress).then(async response => {
      if (response && response.statusCode == 200) {
        this.addressId = response.data;
        this.placeOrderCommon();
      } else {
      }
    })
  }

  changeAddress() {
    this.newPay = false;
    const checkoutLeft = document.querySelectorAll('.checkout-left');
    checkoutLeft.forEach(element => {
      element.classList.remove('stepper-bg');
    })
  }

  async placeOrder() {

    this.isLoadingPay = true;

    if(this.paymentType == ""){
      this.isLoadingPay = false;
      this.toast.error("Please select Payment method to pay amount.")
      return;
    }

    if(this.mUserProfileData.email == null || this.mUserProfileData.email == ''){
      this.isLoadingPay = false;
      $('#email-update').show();
      $("#email-update").attr("class", function(i:any, origValue:any){
        return origValue + " show";
     })
     this.profileData = {
      'first_name':this.mUserProfileData.first_name,
      'last_name': this.mUserProfileData.last_name,
      'id':this.id,
      'email':this.emailFormgroup.controls['email'].value
    }
    return;
    
    }
    const checkAddress = this.wsUserProfileService.checkPinCode(this.selectedAddress.postal_code)
    await lastValueFrom(checkAddress).then(async response => {
      if (response[0] && response[0].Status == 'Success') {
        this.placeOrderCommon()
      } else {
        this.toast.error("Please enter valid Pincode")
      }
    })
  }

  async placeOrderCommon() {
    this.isLoadingPay = true;
    this.mCheckoutRequest.user_id = "" + SharedPrefrences.getUserId();
    this.mCheckoutRequest.user_address_id = this.selectedAddress.id;
    this.mCheckoutRequest.total_cost = this.calculateTotalAmount();
    this.mCheckoutRequest.total_discount_amount = this.discountAmount;
    this.mCheckoutRequest.total_redeem_point = 0;
    this.mCheckoutRequest.order_tracking_number = 0;
    this.mCheckoutRequest.shipping_charge = this.totalAmountWithoutDiscount < 499 ? 70 : 0;
    this.mCheckoutRequest.warehouse_id = this.mAddUpdateCartModuleResponse.data[0].productdetail.warehouse_id;
    this.mCheckoutRequest.total_tax_amount = this.taxableAmount;
    this.mCheckoutRequest.discount_code = this.discountCode;
    localStorage.setItem("addressSelected",this.selectedAddress.id)
    if(this.discountCode){
      localStorage.setItem("discountCode",this.discountCode)
    }
    if (this.paymentType == 'cod') {
      this.mCheckoutRequest.cod = true;
    }
    if (this.paymentType != 'cod') {
      this.mCheckoutRequest.cod = false;
    }

    if(this.discount && this.discount.on_cart_value == true){
      const totalDiscountAmount = this.discountAmount;
      const totalQuantity = this.mCheckoutRequest.productorderdetails.reduce((acc: any, item: any) => acc + item.qty, 0);
      this.mCheckoutRequest.productorderdetails.forEach((product: any) => {
        const discountAmount = (totalDiscountAmount * product.qty) / totalQuantity;
        product.discountamout = Math.round(discountAmount);
        if(this.discountCode && this.discountAmount){
          product.discount_code = this.discountCode;
        }
        else{
          product.discount_code = null;
        }
      });
    }
    else{
      this.mAddUpdateCartModuleResponse.data.forEach((item1: any) => {
        const matchingItem2 = this.mCheckoutRequest.productorderdetails.find((item2: any) => item2.product_id === item1.product_id);
        if (matchingItem2) {
          if(item1 && item1.discountApplied){
            matchingItem2.discountamout = item1.discountApplied;
            matchingItem2.discount_code = this.discountCode;
          }
          else{
            delete matchingItem2.discountamout;
            delete matchingItem2.discount_code;
          }
        }
    });
    }
    localStorage.setItem('orderType', 'order')
    const placeOrder = this.wsCheckoutService.placeOrder(this.mCheckoutRequest)
    await lastValueFrom(placeOrder).then(async response => {
      if (response && response.statusCode == 200) {
        this.isLoadingPay = false;
        if (this.paymentType != 'cod') {
          this.showIframe = true;
          this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(response.data.justPaySessionResponce.payment_Links.web)
          window.location.href = response.data.justPaySessionResponce.payment_Links.web;
          if (this.router.url.indexOf('buynow') == -1) {
            localStorage.setItem("orderType", 'cart')
          } else {
            localStorage.setItem("orderType", 'buynow')
            localStorage.setItem("productId", this.productId)
          }
        } else {
          if (this.router.url.indexOf('buynow') == -1) {
            this.removeCartItems();
          }
          localStorage.setItem('orderType', 'order')
          this.router.navigate(["/paymentstatus/cod"])
        }
        this.applyDiscountFromCart = false;
        this.discountId = null;
        this.discountCode = '';
        this._commonBehaviorChangeService.getToast("Order Placed Successfully");
        this.payment = true;
      } else {
        this.isLoadingPay = false;
        this.toast.error(response.message);
      }
    })
  }

  async removeCartItems() {
    const removeCartList = this.wsShopAllService.removeCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(removeCartList).then(async response => {
      if (response && response.statusCode == 200) {
        this._commonBehaviorChangeService.addCart(true);
        this.getWishList();
      }
    })
  }

  async subscribeEmail() {
    const subscribeDetail = {
      email: this.checkoutPageForm.controls['email'].value,
      is_subscribed: true
    }
    const getAllBrand = this.wsFooter.addSubscribe(subscribeDetail)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
      } else {
      }
    })
  }

  async calculateTax() {
    this.taxableAmount = 0;
    this.productIds = [];
    this.brandIds = []
    this.categoryIds = []
    await this.mAddUpdateCartModuleResponse.data.forEach((product: any) => {
      this.productIds.push(product.product_id)
      this.brandIds.push(product.productdetail.brand_id)
      this.categoryIds.push(product.productdetail.category_id)

      if (product && product.productdetail && product.productdetail.taxes.length > 0) {
        this.taxableAmountCalculate = this.taxableAmountCalculate + ((product.productdetail.your_price * product.qty) * (product.productdetail.taxes[0].tax / 100));
        this.taxableAmount = this.taxableAmount + ((product.productdetail.your_price * product.qty) * product.productdetail.taxes[0].tax / 100);
      }
    })
    this.taxableAmount = parseFloat(this.taxableAmount).toFixed(2)
    this.ProductIds = this.productIds.length < 2 ? this.productIds[0] : this.productIds.join(',')
    this.BrandIds = this.brandIds.length < 2 ? this.brandIds[0] :  this.brandIds.join(',')
    this.CategoryIds = this.categoryIds.length < 2 ? this.categoryIds[0] : this.categoryIds.join(',')
    this.getAllDiscount()
   
  }

  calculateIndividualProductTax(amount: any, taxes: any, from?: any) {
    var taxAmount = 0;
    if (taxes && taxes.tax) {
      taxAmount = (amount * taxes.tax) / 100;
    }
    if (taxAmount == 0) {
      if (from) {
        return 0
      } else {
        return null
      }
    } else {
      if (from) {
        return taxAmount
      } else {
        return '₹' + taxAmount
      }
    }
  }

  calculateTotalAmount() {
   
    this.totalAmountWithoutDiscount = (this.subTotalAmount);
    if(this.totalAmountWithoutDiscount < 499){
      this.shippingCharge = 70;
    }else{
      this.shippingCharge = 0;
    }
    this.totalAmountWithoutDiscount = this.totalAmountWithoutDiscount + this.shippingCharge;
    this.totalAmountWithoutDiscount = parseFloat(this.totalAmountWithoutDiscount).toFixed(2);
    if (this.subTotalAmount < 499) {
      this.cartAmount = 499 - this.subTotalAmount;
    }
    if (this.showDiscountOnTotal) {
      if (this.discount.amount < 1) {
        this.discountApplied = this.totalAmountWithoutDiscount * this.discount.percentage / 100;
        if (this.discountApplied > this.totalAmountWithoutDiscount) {
          this.discountApplied = this.totalAmountWithoutDiscount;
        }
        if (this.discountApplied > this.discount.max_amount && this.discount.max_amount > 0) {
          if (this.discount.max_amount > this.totalAmountWithoutDiscount) {
            this.discountApplied = this.totalAmountWithoutDiscount;
          } else {
            this.discountApplied = this.discount.max_amount;
          }
        }
        this.totalAmount = this.totalAmountWithoutDiscount - this.discountApplied;
      }
      if (this.discount.amount > 0) {
        if (this.totalAmountWithoutDiscount > this.discount.amount) {
          this.discountApplied = this.discount.amount;
        } else {
          this.discountApplied = this.totalAmountWithoutDiscount
        }
        this.totalAmount = this.totalAmountWithoutDiscount - this.discountApplied;
      }
      this.discountAmount = this.discountApplied;
      return  parseFloat(this.totalAmount).toFixed(2);
    } else {
      this.totalAmount = (this.subTotalAmount) - this.discountAmount + (this.shippingCharge);
      return  parseFloat(this.totalAmount).toFixed(2);
    }
  }
  async applyDiscount(discountCode?: any , applyDiscountFromCart?:any) {
    
    if(applyDiscountFromCart == false){
      this.applyDiscountFromCart = false;
    }
    if (this.discountId) {
      this.removeDiscount()
    }
    if (discountCode) {
    }
    if (discountCode != '') {
      const getDiscount = this.wsCheckoutService.getDiscount(discountCode)
      await lastValueFrom(getDiscount).then(async response => {
        if (response && response.statusCode == 200) {
          if (response.data.length < 1) {
            this.toast.error("Please enter valid discount code.")
            return;
          }
          
          this.discount = response.data[0];

          if (this.subTotalAmount < this.discount.minimum_cart_amount) {
            this.toast.error("Discount code is only applicable if your subTotal is more than " + this.discount.minimum_cart_amount)
            return;
          }

          if (this.discount.on_cart_value || this.discount.apply_discount_on_cart_value) {
            this.showDiscountOnTotal = true;
            this.discountCode = discountCode;
            this.discountId = this.discount.id;
          } else {
            if (this.discount.is_all) {
              if (this.discount.type == 'product') {
                this.discountCode = discountCode;
                await this.mAddUpdateCartModuleResponse.data.forEach((product: any, i: any) => {
                  this.discountCalculate((product['productdetail'].your_price * product['qty']), i)
                })
              } else if (this.discount.type == 'brand') {
                this.discountCode = discountCode;
                await this.mAddUpdateCartModuleResponse.data.forEach((product: any, i: any) => {
                  this.discountCalculate((product['productdetail'].your_price * product['qty']), i)
                })
              } else if (this.discount.type == 'category') {
                this.discountCode = discountCode;
                await this.mAddUpdateCartModuleResponse.data.forEach((product: any, i: any) => {
                  this.discountCalculate((product['productdetail'].your_price * product['qty']), i)
                })
              }
              this.discountId = this.discount.id;
              if (this.discountAmount == 0) {
                this.toast.error("Discount Code is not applicable for your selected products")
              }
            } else {
              if (this.discount.type == 'product') {
                this.discountCode = discountCode;
                await this.productIds.forEach((id: any, i: any) => {
                  if (this.discount.product_id_Array.includes(id)) {
                    this.discountCalculate((this.mAddUpdateCartModuleResponse.data[i]['productdetail'].your_price * this.mAddUpdateCartModuleResponse.data[i]['qty']), i)
                  }
                })
              } else if (this.discount.type == 'brand') {
                this.discountCode = discountCode;
                await this.brandIds.forEach((id: any, i: any) => {
                  if (this.discount.brand_id_Array.includes(id)) {
                    this.discountCalculate((this.mAddUpdateCartModuleResponse.data[i]['productdetail'].your_price * this.mAddUpdateCartModuleResponse.data[i]['qty']), i)
                  }
                })
              } else if (this.discount.type == 'category') {
                this.discountCode = discountCode;
                await this.categoryIds.forEach((id: any, i: any) => {
                  if (this.discount.category_id_Array.includes(id)) {
                    this.discountCalculate((this.mAddUpdateCartModuleResponse.data[i]['productdetail'].your_price * this.mAddUpdateCartModuleResponse.data[i]['qty']), i)
                  }
                })
              }
             
              this.discountId = this.discount.id;
              if (this.discountAmount == 0) {
                this.toast.error("Discount Code is not applicable for your selected products")
              }
             
            }
          }
        }
      });
    } else {
      this.toast.error("Please enter Discount Code")
    }
  }

  removeDiscount() {
    this.discountAmount = null;
    this.discountCode = '';
    this.discountId = null;
    this.showDiscountOnTotal = false;
    this.applyDiscountFromCart = false;
    this.mAddUpdateCartModuleResponse.data.forEach((product: any) => {
      if (product.discountApplied) {
        delete product.discountApplied;
        delete product.discountAppliedAmount;
        delete product.discountType;
      }
    })
  }

  discountCalculate(your_price: any, i: any) {
    if (this.discount.amount < 1) {
      this.discountApplied = your_price * this.discount.percentage / 100;
      if (this.discountApplied > your_price) {
        this.discountApplied = your_price;
      }
      if (this.discountApplied > this.discount.max_amount && this.discount.max_amount > 0) {
        if (this.discount.max_amount > your_price) {
          this.discountApplied = your_price;
        } else {
          this.discountApplied = this.discount.max_amount;
        }
      }
      this.mAddUpdateCartModuleResponse.data[i]['discountApplied'] = this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountAppliedAmount'] = your_price - this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountType'] = 'percentage';
      this.discountAmount = this.discountAmount + this.discountApplied;
      return this.discountApplied;
    }
    if (this.discount.amount > 0) {
      if (your_price > this.discount.amount) {
        this.discountApplied = this.discount.amount;
      } else {
        this.discountApplied = your_price
      }
      this.mAddUpdateCartModuleResponse.data[i]['discountApplied'] = this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountAppliedAmount'] = your_price - this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountType'] = 'fix';
      this.discountAmount = this.discountAmount + this.discountApplied;
      return this.discountApplied;
    }

    this.discountApplied = 0
    this.mAddUpdateCartModuleResponse.data[i]['discountApplied'] = this.discountApplied;
    this.mAddUpdateCartModuleResponse.data[i]['discountAppliedAmount'] = your_price - this.discountApplied;
    this.discountAmount = this.discountAmount + this.discountApplied;
    this.viewOffers = false;

    return this.discountApplied;
  }



  choosePaymentType(paymentType: any) {
    this.paymentType = paymentType
  }

  async getAllDiscount() {
    const getAllDiscount = this.wsCheckoutService.getAllDiscountByProductIds(this.ProductIds, this.BrandIds, this.CategoryIds)
    await lastValueFrom(getAllDiscount).then(async response => {
      if (response && response.statusCode == 200) {
        this.discountList = []
        await response['data'].forEach(async (discount: any) => {
          if (discount && discount.discounts.length > 0) {
            await discount.discounts.forEach((d: any) => {
              if (this.discountList.length < 1) {
                this.discountList.push(d)
              } else {
                var haveDiscount = this.discountList.findIndex((discountcheck: any) => discountcheck.id == d.id)
                if (haveDiscount == -1) {
                  this.discountList.push(d)
                }
              }
            })
          }
        })
      }
    });
   
  }

  async addToCartCommon(product: any, index?: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.id;
    this.mAddUpdateCartModule.iswishlistitem = false;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    } else {
      this.mAddUpdateCartModule.qty = 1;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModule = new MAddUpdateCartModule();
        this._commonBehaviorChangeService.addCart(true);
      } else {
        console.log("something went wrong")
      }
    })
  }

  saveNewAddress(event: any) {
    if (event) {
      
      $('#add-update').hide();
      this.mAddressListReq.userId = this.id
      this.getAddressList(this.mAddressListReq)
    }
    this.viewForm = ''
    this.addressData = null;
    $('#add-update').hide();
    $(".modal-backdrop").hide();
  }

  get f() {
    return this.emailFormgroup.controls;
  }

  async addtoCart(product: any, addRemove?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.iswishlistitem = false;
    this.mAddUpdateCartModule.product_id = product.id;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      product.isLoading = true;
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    } else {
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.getWishList();
        if (addRemove && addRemove == 'add') {
          this._commonBehaviorChangeService.getToast('Product added to cart successfully');
        }
        if (addRemove && addRemove == 'remove') {
          this._commonBehaviorChangeService.getToast('Product removed from cart successfully')
        }
        if (addRemove && addRemove == 'delete') {
          this._commonBehaviorChangeService.getToast('Product removed from cart successfully')
        }
        product.isLoading = false;      
      } else {
        console.log("something went wrong")
      }
    })
  }

  addCartItem(product: any, i: any) {
    this.mAddUpdateCartModule.qty = product.qty + 1;
    if (this.router.url.indexOf('/checkout-new/buynow') == -1 && this.router.url.indexOf('/checkout-new-mob/buynow') == -1) {
      product.productdetail.isLoading = true;
      this.addtoCart(product.productdetail, 'add');
      
    } else {
      this.mAddUpdateCartModuleResponse.data[i].qty = product.qty + 1;
      this.calculateTotal();
      if(this.discountId && !this.applyDiscountFromCart){
        this.applyDiscount(this.discountCode)
      }
    }
    
  }

  async removeCartItem(product: any, i: any) {
    this.mAddUpdateCartModule.qty = product.qty - 1;
      if (this.router.url.indexOf('/checkout-new/buynow') == -1 && this.router.url.indexOf('/checkout-new-mob/buynow') == -1) {
          product.productdetail.isLoading = true;
        this.addtoCart(product.productdetail, 'remove');
      } else {
        if(this.mAddUpdateCartModule.qty == 0){
          this.mAddUpdateCartModuleResponse.data = this.mAddUpdateCartModuleResponse.data.filter((product:any, index:any) => index != i);
        }else{
          this.mAddUpdateCartModuleResponse.data[i].qty = product.qty - 1;
        }
        await this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product['productdetail'].cartQty = cartPresent[0].qty;
          }
        })
       await this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.forEach((cartItem: any) => {
          if (this.mWishlistData && this.mWishlistData.length > 0) {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === cartItem.productdetail.id && cartItem.qty > 0) });
            if (present) {
              cartItem.like = true;
            } else {
              cartItem.like = false;
            }
          }
        })
        this.wishlistData = this.mWishlistData.filter((product:any) => !product['productdetail'].cartQty || product['productdetail'].cartQty < 1)
        this.calculateTotal();
        if(this.discountId && !this.applyDiscountFromCart){
          this.applyDiscount(this.discountCode)
        }
      }
  }

  deleteCartItem(product: any, i: any) {
    this.mAddUpdateCartModule.qty = 0;
    product.productdetail.isLoading = true;
    this.addtoCart(product.productdetail, 'delete')
  }

  viewAllOffers() {
    this.viewOffers = true;
  }

  async addToWhislist(product: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.productdetail.id;
    this.mAddUpdateCartModule.iswishlistitem = true;
    if (productType == 'wishList') {
      const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.productdetail.id })
      if (wishlist > -1) {
        this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
      } else {
        delete this.mAddUpdateCartModule.id
      }
      this.mAddUpdateCartModule.qty = 0;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = product.like ? false : true;
      if (product.like) {
        const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.productdetail.id })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
      }
    }
    this.mAddUpdateCartModule.qty = product.like ? 0 : 1;
    var productIndex = this.mAddUpdateCartModuleResponse.data.findIndex((cartItem: any) => cartItem.product_id == product.product_id)
    if (this.mAddUpdateCartModule.qty > 0) {
      this.mAddUpdateCartModuleResponse.data[productIndex].like = true;
    } else {
      this.mAddUpdateCartModuleResponse.data[productIndex].like = false;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this._commonBehaviorChangeService.addWishlist(true)
      } else {
        console.log("something went wrong")
      }
    })
  }

  async addInWishlist(product: any, val: any) {
    this.type = val;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToWhislist(product, this.type)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToWhislist(product, this.type)
        }
      })
    }
  }

  onSubmitEmail(){
    if(this.emailFormgroup.invalid){
      this.emailFormgroup.markAllAsTouched();
      return;
    }
    this.profileData.email = this.emailFormgroup.controls['email'].value;
    this.updateProfile1(this.profileData)
  }

  async updateProfile1(profileData:any){
    const updateProfile = this.wsUserProfileService.updateProfile(profileData)
    await lastValueFrom(updateProfile).then(async response => {
      if (response && response.statusCode == 200) {
        SharedPrefrences.setUserData(response.data)
        this._commonBehaviorChangeService.updateProfileData(true)
        window.location.reload();
      } else {

      }
    })

  }

  closeModal(){
    $('#email-update').hide();
    $(".modal-backdrop").hide();
    this.emailFormgroup.reset();
  }
}
